module.exports = __webpack_public_path__ + "static/media/bat.80f1b565.svg";